import styled from 'styled-components';
import { MAX_MOBILE_WIDTH } from '../../../../utils/constants';

export const VariantDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #e9e9e9;
  border-bottom: 1px solid #e9e9e9;
  padding-top: 24px;
`;

export const VariantGroupsContainer = styled.span`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    gap: 24px;
  }
`;

export const VariantDescriptionFilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    margin-left: 16px;
  }
`;

export const VariantDescriptionFilterHeading = styled.div`
  display: flex;
  font-weight: 400;
  font-size: 14px;
  padding-top: 5px;
  color: #414141;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    transform: none;
  }
`;

export const VariantDescriptionFilterContent = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    margin-top: ${(props) => (props?.isColor ? '' : '8px')};
  }
`;

export const VariantDescriptionCartCta = styled.div`
  display: flex;
  margin-bottom: 24px;
`;

export const ActiveVariantName = styled.span`
  margin-left: 2px;
  font-weight: 500;
  color: #000000;
`;
